import { downloadCsvRows } from '../../../helpers/downloadCsvRows'
import { getCurrentDate, getTimestampFromDateTime } from '../../../helpers/formatDate'
import { getSettlementStatusUI } from '../indexFilters'

export const exportSettlementsTableCsv = (rows) => {
  downloadCsvRows(
    [
      ['Fecha y hora', '# de liquidación', 'Creado por', '# ERP', 'Total cobrado', 'Estado'],
      ...rows.map((row) => [
        getTimestampFromDateTime(row.collected_at),
        row.uid,
        `${row.user_uid} - ${row.user_full_name}`,
        row.erp_document_reference || '',
        row.total_amount,
        getSettlementStatusUI(row.approval_status || row.status).label
      ])
    ],
    `Liquidaciones_${getCurrentDate()}.csv`
  )
}
